const hostApi = "https://tradexc-server.com";
const baseURLApi = "https://api.accountxc.com:3100";
const redirectUrl = "https://api.accountxc.com:3100";
const portApi = 8080;

export default {
  light: {
    //primary: "#536dfe",
    primary: "#74C365",
    primaryConst: "#536dfe",
    secondary: "#FF5C93",
    secondaryConst: "#FF5C93",
    error: "#FF4081",
    warning: "#FFC260",
    success: "#3CD4A0",
    successConst: "#3CD4A0",
    orangeConst: "#FFB347",
    yellowConst: "#FFD700",
    redConst: "#D0312D",
    purpleConst: "#663399",
    lightBlueConst: "#73c2fb",
    lightGreenConst: "#7CFC00",
    darkGreenConst: "#3CB043",
    lightPinkConst: "#FC94AF",
    hotPinkConst: "#FF1694",
    
    info: "#9013FE",
    greyBold: '#4a4a4a',
    greyBoldConst: '#4a4a4a',
    greyMedium: '#6e6e6e',
    greyTint: '#b9b9b9',
    default: '#e0e0e0',
    iconColor: "#FFFFFF"
  },
  dark: {
    primary: "#536dfe",
    primaryConst: "#536dfe",
    secondary: "#FF5C93",
    secondaryConst: "#FF5C93",
    success: "#3CD4A0",
    successConst: "#3CD4A0",
    orangeConst: "#FFB347",
    error: "#FF4081",
    greyMedium: '#bfbfbf',
    greyBold: '#d6d6d6',
    greyBoldConst: '#4a4a4a',
    greyTint: '#9b9b9b',
    default: '#e0e0e0',
  },
  hostApi,
  portApi,
  baseURLApi,
  redirectUrl,
  isBackend: process.env.VUE_APP_BACKEND,
  remote: "https://api.accountxc.com:3100/login",
  auth: {
    email: '',
    password: ''
  }
};


